export function resolveAutomationCanvasSelection(input: {
  additive: boolean;
  selectedIds: readonly string[];
  targetId: string;
}): string[] {
  if (!input.additive) return [input.targetId];
  return Array.from(new Set([...input.selectedIds, input.targetId]));
}
